import { withTranslation } from "react-i18next";
import WithRouter from "../../../../components/Common/WithRouter";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { Dropdown } from "primereact/dropdown";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { request } from "../../../../utils/Request";
import * as XLSX from 'xlsx';
import { utcDateToLocalDate } from "../../../../utils/Helper";
import { find, get } from "lodash";

const InProgressOrderDamageCaseExcel = (props: any) => {
    const { t, moduleState, visibility, onClose } = props;
    const [exporting, setExporting] = useState(false);
    const [panelState, setPanelState] = useState<boolean>(false);

    const validationSchema = Yup.object().shape({
        format: Yup.string().required(t('format is required')),
    });

    const handleSubmit = async (values: any) => {
        setExporting(true);
        try {
            const response = await request({
                url: '/suppliers/order/damage/cases/in-progress',
                params: {
                    ...moduleState,
                    ...values,
                    per_page: 10000, // Get all records for export
                }
            });

            const { data } = response.data;

            if ( data && data.length > 0 ) {
                const exportData = data.map((item: any) => ( {
                    [t('VIN')]: get(item, ['order', 'vin_number']) || '',
                    [t('case number')]: get(item, ['case_number']) || '',
                    [t('carrier')]: get(item, ['supplier_carrier']) || '',
                    [t('provider')]: get(find(props.dropdowns?.providers || [], { id: get(item, ['source_type']) }), ['label']) || get(item, ['source_type']) || '',
                    [t('insurance company')]: get(item, ['insurance_company']) || '',
                    [t('assignee')]: get(item, ['assignee']) || '',
                    [t('sub contractor')]: get(item, ['sub_contractor']) || '',
                    [t('no. of comments')]: get(item, ['histories', 'length']) || 0,
                    [t('gate in')]: get(item, ['gate_in']) ? utcDateToLocalDate(get(item, ['gate_in'])) : '',
                    [t('damage codes')]: (get(item, ['damage_codes']) || []).map((dc: any) => get(dc, ['code'])).join(', ') || '',
                    [t('damage date')]: get(item, ['damage_date']) ? utcDateToLocalDate(get(item, ['damage_date'])) : '',
                    [t('status')]: get(item, ['status']) || '',
                    [t('notes')]: get(item, ['notes']) || '',
                    [t('created at')]: get(item, ['created_at']) ? utcDateToLocalDate(get(item, ['created_at'])) : '',
                    [t('updated at')]: get(item, ['updated_at']) ? utcDateToLocalDate(get(item, ['updated_at'])) : '',
                } ));

                const ws = XLSX.utils.json_to_sheet(exportData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, t('in-progress damage cases'));

                const fileName = `in_progress_damage_cases_${ new Date().toISOString().split('T')[0] }.${ values.format }`;
                XLSX.writeFile(wb, fileName);
            }

            onClose();
        } catch (error) {
            console.error('Export error:', error);
            props.toastify(t("export failed"), "error");
        } finally {
            setExporting(false);
        }
    };

    const onCloseHandler = () => {
        setPanelState(false);

        if ( onClose ) {
            onClose();
        }
    };

    useEffect(() => {
        if ( visibility ) {
            setPanelState(visibility);
        }
    }, [visibility]);

    const formatOptions = [
        { label: 'Excel (.xlsx)', value: 'xlsx' },
        { label: 'CSV (.csv)', value: 'csv' },
    ];

    return (
        <Sidebar
            header={
                <div className="bg-body-tertiary card-header">
                    <h5 className="card-title mt-0">{ t('export to excel') }</h5>
                    <p>{ t("export in-progress damage cases data to excel or csv format") }</p>
                </div>
            }
            visible={ panelState }
            position="right"
            onHide={ onCloseHandler }
            blockScroll={ true }
            style={ { width: '500px' } }
            closeOnEscape={ false }
        >
            <div style={ {
                height: '3px',
                background: 'linear-gradient(90deg, var(--primary-color) 0%, rgba(33, 150, 243, 0) 50%)'
            } }></div>

            <Formik
                initialValues={ { format: 'xlsx' } }
                validationSchema={ validationSchema }
                onSubmit={ handleSubmit }
            >
                { ({ values, setFieldValue }) => (
                    <Form>
                        <Row className="mt-4">
                            <Col sm={ 12 }>
                                <label className="form-label">{ t('export format') }</label>
                                <Dropdown
                                    value={ values.format }
                                    options={ formatOptions }
                                    onChange={ (e) => setFieldValue('format', e.value) }
                                    placeholder={ t('select format') }
                                    className="w-100"
                                    optionLabel="label"
                                    optionValue="value"
                                />
                            </Col>
                        </Row>

                        <div className="filter-card-footer" style={ { width: '485px' } }>
                            <Button
                                type="submit"
                                disabled={ exporting }
                                tooltip={ t("to export data") }
                                size="small"
                                outlined
                                tooltipOptions={ { position: 'top' } }
                            >
                                <i className="pi pi-download me-2" />
                                { exporting ? t("exporting...") : t("export") }
                            </Button>
                            <Button
                                type="button"
                                onClick={ onCloseHandler }
                                tooltip={ t("close export panel") }
                                className="ms-2"
                                size="small"
                                severity="danger"
                                outlined
                                tooltipOptions={ { position: 'top' } }
                            >
                                <i className="pi pi-times me-2" />
                                { t("close") }
                            </Button>
                        </div>
                    </Form>
                ) }
            </Formik>
        </Sidebar>
    );
};

export default withTranslation()(WithRouter(InProgressOrderDamageCaseExcel));

